import React from "react";
import Stack from "../mui/Stack";
const Container = ({ children, sx }) => {
	return (
		<Stack
		// height="100%"
			sx={{ py: 2, backgroundColor: "#13172A", ...sx }}
		>
			{children}
		</Stack>
	);
};

export default Container;
